import ReactDOM from 'react-dom';
import App from './App';

import "./assets/reset.css"
import "./assets/style.css"

ReactDOM.render(<App />, document.querySelector(".root"));
